import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import { InvoiceFlowTaskResponse } from "../model";

export default class InvoiceFlowTaskApi {
  static getInvoices(): Promise<InvoiceFlowTaskResponse> {
    return http.get<ApiResponse<InvoiceFlowTaskResponse>>(`invoice-flow/tasks`).then(handleApiResponse);
  }
}
